import { render, staticRenderFns } from "./privacypolicy.vue?vue&type=template&id=a182214e&scoped=true"
import script from "./privacypolicy.vue?vue&type=script&lang=js"
export * from "./privacypolicy.vue?vue&type=script&lang=js"
import style0 from "./privacypolicy.vue?vue&type=style&index=0&id=a182214e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a182214e",
  null
  
)

export default component.exports